import { Component, OnInit } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import {
  FormBuilder,
  FormControl,
  FormGroup,
  Validators,
} from "@angular/forms";

import { TableService } from "@kortobaa-front/k-ng-datatable";

import {
  RolesId,
  SavedUserData,
  UserData,
  UserInputMode,
  UserInputType,
  UserRoles,
} from "src/app/shared/models/interfaces";
import { HandleUsersService } from "../serviecs/handle-users.service";
import { addDuplicatedError } from "src/app/shared/helpers/formControlers";
import { HttpClient } from "@angular/common/http";
import { environment } from "src/environments/environment";
import { getHeadersWithToken } from "src/app/shared/helpers/getHeadersWithToken";
import { DataService } from "src/app/shared/services/data.service";
import { MatDialog } from "@angular/material/dialog";
import { TranslateService } from "@ngx-translate/core";
import { ConfirmDialogComponent } from "src/app/shared/components/confirm-dialog/confirm-dialog.component";
import * as moment from 'moment-hijri';
@Component({
  selector: "app-save-user",
  templateUrl: "./save-user.component.html",
  styleUrls: ["./save-user.component.scss"],
})
export class SaveUserComponent implements OnInit {
  readonly SavedUserData = SavedUserData;
  readonly UserInputMode = UserInputMode;
  readonly UserInputType = UserInputType;
  readonly UserRoles = UserRoles;

  userRole: UserRoles;
  userName: string;
  userId: number;
  userData: UserData = {} as UserData;
  isLoading = false;
  isAddNewUser = true;
  editableSection: SavedUserData | null;
  isAddingNewUser = false;
  isEditingUser = false;
  usercasesCount = 0;
  userInquiriesCount = 0;
  userCases: any = [];
  userInquries: any = [];
  isViewing: boolean = false;
  currentCopiedText!: string;
  isNewUserPage: boolean = false;
  isNewUserFlag: boolean = false;
  userDataOptional!: any;
  readonly today = new Date();
  nationality!: string;
  isActionLoading: boolean = false;
  calenderType: 'hijri' | 'gregorian' = 'gregorian';
  saveUserForm = new FormGroup({
    [SavedUserData.PERSONAL_DATA]: new FormGroup({
      firstName: new FormControl("", [
        Validators.required,
        Validators.pattern(
          "^[A-Za-z\u0621-\u064A\0-9][A-Za-z\u0621-\u064A\0-9][A-Za-z\u0621-\u064A\0-9]{0,49}$"
        ),
      ]),
      secondName: new FormControl("", [
        Validators.required,
        Validators.pattern(
          "^[A-Za-z\u0621-\u064A\0-9][A-Za-z\u0621-\u064A\0-9][A-Za-z\u0621-\u064A\0-9]{0,49}$"
        ),
      ]),
      thirdName: new FormControl("", [
        Validators.required,
        Validators.pattern(
          "^[A-Za-z\u0621-\u064A\0-9][A-Za-z\u0621-\u064A\0-9][A-Za-z\u0621-\u064A\0-9]{0,49}$"
        ),
      ]),
      lastName: new FormControl("", [
        Validators.required,
        Validators.pattern(
          "^[A-Za-z\u0621-\u064A\0-9][A-Za-z\u0621-\u064A\0-9][A-Za-z\u0621-\u064A\0-9]{0,49}$"
        ),
      ]),
    }),
    [SavedUserData.IDENTITY_DATA]: new FormGroup({
      nid: new FormControl("", [
        Validators.required,
        Validators.pattern(
          "^[A-Za-z\u0621-\u064A\0-9][A-Za-z\u0621-\u064A\0-9][A-Za-z\u0621-\u064A\0-9]{0,49}$"
        ),
      ]),
    }),
    [SavedUserData.CONTACT_DATA]: new FormGroup({
      email: new FormControl("", [Validators.email]),
      phone: new FormControl("", [
        Validators.required,
        Validators.pattern("^\\d{9}$")
      ]),
    }),
    [SavedUserData.OUR_CUSTOMER_DATA]: new FormGroup({
      isDisabled: new FormControl(1, [Validators.required]),
      blackListed: new FormControl(false, [Validators.required]),
    }),
    [SavedUserData.SPOUSE_DATA]: new FormGroup({
      spouseName: new FormControl(""),
      spousePhone: new FormControl("", [
        Validators.pattern("^\\d{9}$")
      ]),
      spouseNid: new FormControl("", [
        Validators.pattern("^(?:[12][0-9]{9}|41[0-9]{8})$")
      ]),
    }),
  });

  constructor(
    private _activatedRoute: ActivatedRoute,
    private _router: Router,
    private _tableService: TableService,
    private _handleUsersService: HandleUsersService,
    private _http: HttpClient,
    private dataService: DataService,
    private _dialog: MatDialog,
    public translate: TranslateService,
  ) { }

  async ngOnInit(): Promise<void> {
    this.isNewUserPage = this._router.url == "/new-user/user" ? true : false;
    this._activatedRoute.queryParams.subscribe(({ userName }) => {
      this.userName = userName;
    });

    this.userRole = this._activatedRoute.snapshot.paramMap.get(
      "userRole"
    ) as UserRoles;

    this.isNewUserFlag = this._router.url == `/new-user/${this.userRole}` ? true : false;

    const ourCustomerDataForm = this.saveUserForm.controls[
      SavedUserData.OUR_CUSTOMER_DATA
    ] as FormGroup;

    const ourPersonalDataForm = this.saveUserForm.controls[
      SavedUserData.PERSONAL_DATA
    ] as FormGroup;

    const ourIdentityDataForm = this.saveUserForm.controls[
      SavedUserData.IDENTITY_DATA
    ] as FormGroup;

    if ([UserRoles.lawyer, UserRoles.conciliator].includes(this.userRole)) {
      ourCustomerDataForm.addControl(
        "assignedCases",
        new FormControl("", [Validators.required])
      );

      ourCustomerDataForm.addControl(
        "signedContractType",
        new FormControl("", [Validators.required])
      );

      ourCustomerDataForm.addControl(
        "perpetualMechanism",
        new FormControl("presence", [Validators.required])
      );
    }
    if (this.userRole === UserRoles.conciliator) {
      this.saveUserForm.addControl(
        SavedUserData.PROFESSIONAL_DATA,
        new FormGroup({
          profession: new FormControl("", [
            Validators.required,
            Validators.pattern(
              "[/\n/sa-zA-Z0-9 ٌ؛ء-ي’، ً ّ َ ُ؟‘ ِ ٍ~ْ\u0020-\u007e\u00a0-\u00ff\u0152\u0153\u0178]{1,50}$"
            ),
          ]),
          qualification: new FormControl("", [
            Validators.required,
            Validators.pattern(
              "[/\n/sa-zA-Z0-9 ٌ؛ء-ي’، ً ّ َ ُ؟‘ ِ ٍ~ْ\u0020-\u007e\u00a0-\u00ff\u0152\u0153\u0178]{1,100}$"
            ),
          ]),
          scientificExpertise: new FormControl("", [Validators.required]),
          experienceDuration: new FormControl("", [
            Validators.required,
            Validators.pattern(
              "[/\n/sa-zA-Z0-9 ٌ؛ء-ي’، ً ّ َ ُ؟‘ ِ ٍ~ْ\u0020-\u007e\u00a0-\u00ff\u0152\u0153\u0178]{1,200}$"
            ),
          ]),
        })
      );
    }
    if (this.userRole === UserRoles.lawyer) {
      this.saveUserForm.addControl(
        SavedUserData.LAWYER_DATA,
        new FormGroup({
          licenseNumber: new FormControl("", [
            Validators.required,
            Validators.pattern(
              "[/\n/sa-zA-Z0-9 ٌ؛ء-ي’، ً ّ َ ُ؟‘ ِ ٍ~ْ\u0020-\u007e\u00a0-\u00ff\u0152\u0153\u0178]{1,50}$"
            ),
          ]),
          licenseDate: new FormControl("", [Validators.required]),
          licenseImage: new FormControl("", [Validators.required]),
          qualification: new FormControl("", [
            Validators.required,
            Validators.pattern(
              "[/\n/sa-zA-Z0-9 ٌ؛ء-ي’، ً ّ َ ُ؟‘ ِ ٍ~ْ\u0020-\u007e\u00a0-\u00ff\u0152\u0153\u0178]{1,100}$"
            ),
          ]),
          scientificExpertise: new FormControl("", [Validators.required]),
          experienceDuration: new FormControl("", [
            Validators.required,
            Validators.pattern(
              "[/\n/sa-zA-Z0-9 ٌ؛ء-ي’، ً ّ َ ُ؟‘ ِ ٍ~ْ\u0020-\u007e\u00a0-\u00ff\u0152\u0153\u0178]{1,200}$"
            ),
          ]),
          trainingCourses: new FormControl([], [Validators.required]),
        })
      );
      ourPersonalDataForm
        .get("secondName")
        .setValidators([
          Validators.pattern(
            "^[A-Za-z\u0621-\u064A\0-9][A-Za-z\u0621-\u064A\0-9][A-Za-z\u0621-\u064A\0-9]{0,49}$"
          ),
        ]);
      ourPersonalDataForm
        .get("thirdName")
        .setValidators([
          Validators.pattern(
            "^[A-Za-z\u0621-\u064A\0-9][A-Za-z\u0621-\u064A\0-9][A-Za-z\u0621-\u064A\0-9]{0,49}$"
          ),
        ]);
      ourPersonalDataForm
        .get("lastName")
        .setValidators([
          Validators.pattern(
            "^[A-Za-z\u0621-\u064A\0-9][A-Za-z\u0621-\u064A\0-9][A-Za-z\u0621-\u064A\0-9]{0,49}$"
          ),
        ]);

      ourCustomerDataForm.addControl(
        "service",
        new FormControl([], [Validators.required])
      );
    }
    if (this.userRole === UserRoles.supervisor) {
      ourCustomerDataForm.addControl(
        "autoAssign",
        new FormControl("", [Validators.required])
      );
    }
    if (!this.isNewUserPage) {
      ourPersonalDataForm.addControl(
        "birthdate",
        new FormControl("", [Validators.required])
      );

      ourPersonalDataForm.addControl(
        "maritalStatus",
        new FormControl("", [Validators.required])
      );

      ourPersonalDataForm.addControl(
        "gender",
        new FormControl("", [Validators.required])
      );

      ourIdentityDataForm.addControl(
        "nidDate",
        new FormControl("", [Validators.required])
      );

      ourIdentityDataForm.addControl(
        "nid_image",
        new FormControl("", [Validators.required])
      );
    }

    // If there is a user, we show user data
    const userId = this._activatedRoute.snapshot.paramMap.get("userId");

    this.isAddNewUser = !Boolean(userId);

    if (userId) {
      this.userId = Number(userId);

      this.userData = (await this.getUserData(this.userId))[0];
      this.userDataOptional = this.userData;
      this.nationality =
        (!(!!this.userData.nid && this.userData.nid.startsWith("1"))
          ? "غير "
          : "") + "سعودي" || "";

      if (this.userData.phone.startsWith("+966")) {
        this.userData.phone = this.userData.phone.slice(4);
      }
      this.isViewing = true;
      this._assignUserData(this.userData);
      this.getUserStats(this.userId);
    }
  }

  async getUserData(id: number) {
    this.isLoading = true;
    let userData: [UserData];
    try {
      // HACK: to get data for a single user
      this._tableService.tableUrl = `admin/usersByRole/${this.userRole}`;

      userData = await this._tableService
        .getData<[UserData]>({
          where: { and: [{ id }] },
        })
        .toPromise();
    } catch (error) {
      console.error(error);
    }

    this.isLoading = false;
    return userData;
  }

  async getUserStats(id: any) {
    this._http
      .get(`${environment.apiHost}admin/user-cases-inquries/${id}`, {
        headers: getHeadersWithToken(),
      })
      .subscribe((data: any) => {
        this.usercasesCount = data.userCasesCount;
        this.userInquiriesCount = data.userInquriesCount;
        this.userCases = data.userCases;
        this.userInquries = data.userInquries;
      });
  }

  private _assignUserData(userData: UserData) {
    // Loop over controls
    Object.keys(this.saveUserForm.controls).forEach((controlName) => {
      for (const field in userData) {
        // Loop over all non object fields
        if (typeof userData[field] !== "object") {
          (this.saveUserForm.controls[controlName] as FormGroup).controls[
            field
          ]?.setValue(userData[field]);
        } else {
          // Loop over nested object fields
          for (const nestedField in userData[field]) {
            (this.saveUserForm.controls[controlName] as FormGroup).controls[
              nestedField
            ]?.setValue(userData[field][nestedField]);
          }
        }
      }
    });

    // Assign spouse data from userProfile if exists
    if (userData.userProfile) {
      const spouseFormGroup = this.saveUserForm.controls[SavedUserData.SPOUSE_DATA] as FormGroup;
      spouseFormGroup.controls['spouseName']?.setValue(userData.userProfile.spouseName || "");

      // Strip +966 prefix from spouse phone for editing
      let spousePhone = userData.userProfile.spousePhone || "";
      if (spousePhone.startsWith("+966")) {
        spousePhone = spousePhone.slice(4);
      }
      spouseFormGroup.controls['spousePhone']?.setValue(spousePhone);

      spouseFormGroup.controls['spouseNid']?.setValue(userData.userProfile.spouseNid || "");
    }
  }

  get isEditPersonalData(): UserInputMode {
    return this.isAddNewUser ||
      this.editableSection === SavedUserData.PERSONAL_DATA
      ? UserInputMode.EDIT
      : UserInputMode.VIEW;
  }

  get isEditIdentityData(): UserInputMode {
    return this.isAddNewUser ||
      this.editableSection === SavedUserData.IDENTITY_DATA
      ? UserInputMode.EDIT
      : UserInputMode.VIEW;
  }

  get isEditProfessionalData(): UserInputMode {
    return this.isAddNewUser ||
      this.editableSection === SavedUserData.PROFESSIONAL_DATA
      ? UserInputMode.EDIT
      : UserInputMode.VIEW;
  }

  get isEditLawyerData(): UserInputMode {
    return this.isAddNewUser ||
      this.editableSection === SavedUserData.LAWYER_DATA
      ? UserInputMode.EDIT
      : UserInputMode.VIEW;
  }

  get isEditContactData(): UserInputMode {
    return this.isAddNewUser ||
      this.editableSection === SavedUserData.CONTACT_DATA
      ? UserInputMode.EDIT
      : UserInputMode.VIEW;
  }

  get isEditOurCustomerDATA(): UserInputMode {
    return this.isAddNewUser ||
      this.editableSection === SavedUserData.OUR_CUSTOMER_DATA
      ? UserInputMode.EDIT
      : UserInputMode.VIEW;
  }

  get isEditSpouseData(): UserInputMode {
    return this.editableSection === SavedUserData.SPOUSE_DATA
      ? UserInputMode.EDIT
      : UserInputMode.VIEW;
  }

  async onSubmit(section: SavedUserData) {
    const userFormValue = this.saveUserForm.value;
    // // Add new user
    if (section === SavedUserData.ALL) {
      const newUserData = { additionalData: {} } as UserData;
      for (const field in userFormValue) {
        const nestedValue = userFormValue[field];
        for (const nestedField in nestedValue) {
          if (
            ["username", "phone", "email", "nid", "isDisabled"].includes(
              nestedField
            )
          ) {
            newUserData[nestedField] = nestedValue[nestedField];
          } else {
            newUserData.additionalData[nestedField] = nestedValue[nestedField];
            if (nestedField == "birthdate") {
              if ((this, this.calenderType === "gregorian")) {
                newUserData.additionalData["birthdate"] = nestedValue[nestedField];
                newUserData.additionalData["birthdateHijri"] = null;
              } else {
                newUserData.additionalData["birthdateHijri"] = nestedValue[nestedField];
                newUserData.additionalData["birthdate"] = null;
              }
            }
          }
        }
      }

      // Add usename based on firstName and lastName
      newUserData.username = `${newUserData.additionalData.firstName} ${newUserData.additionalData.lastName}`;
      newUserData.roleId = RolesId[this.userRole];
      if (this.userRole == UserRoles.user) {
        newUserData['isFinishedAdditionalStep'] = false;
      }

      // HACK: to skip validation
      newUserData.isDisabled = Boolean(newUserData.isDisabled) as unknown as number;

      try {
        this.isAddingNewUser = true;
        newUserData.phone = "+966" + newUserData.phone;
        newUserData.verified = true;
        await this._handleUsersService.createNewUser(newUserData);

        this.goBack();
      } catch (error) {
        console.error(error);

        if (error.error.error) {
          const { message } = error.error.error;
          this._checkDuplicatedError(
            message,
            "Email",
            SavedUserData.CONTACT_DATA,
            "email"
          );

          this._checkDuplicatedError(
            message,
            "Phone",
            SavedUserData.CONTACT_DATA,
            "phone"
          );

          this._checkDuplicatedError(
            message,
            "National ID",
            SavedUserData.IDENTITY_DATA,
            "nid"
          );
        }
      }

      this.isAddingNewUser = false;
    }
    // Update spouse profile section
    else if (section === SavedUserData.SPOUSE_DATA) {
      let spousePhone = userFormValue[SavedUserData.SPOUSE_DATA].spousePhone || undefined;
      // Add +966 prefix to spouse phone if it doesn't have it
      if (spousePhone && !spousePhone.startsWith("+966")) {
        spousePhone = "+966" + spousePhone;
      }

      const spouseData = {
        spouseName: userFormValue[SavedUserData.SPOUSE_DATA].spouseName || undefined,
        spousePhone: spousePhone,
        spouseNid: userFormValue[SavedUserData.SPOUSE_DATA].spouseNid || undefined,
      };

      try {
        this.isEditingUser = true;
        await this._handleUsersService.updateUserProfile(this.userId, spouseData);

        // Update local userData with new spouse info
        if (!this.userData.userProfile) {
          this.userData.userProfile = {};
        }
        this.userData.userProfile.spouseName = spouseData.spouseName;
        this.userData.userProfile.spousePhone = spouseData.spousePhone;
        this.userData.userProfile.spouseNid = spouseData.spouseNid;

        this.editableSection = null;
        this.dataService.notification("تم حفظ بيانات الزوجين بنجاح", 'success-snackbar');
      } catch (error) {
        this.dataService.notification("حدث خطأ أثناء حفظ البيانات", 'error-snackbar');
      }

      this.isEditingUser = false;
    }
    // Update the corresponding section
    else {
      const updatedUserData = { additionalData: {} } as UserData;
      for (const field in userFormValue[section]) {
        if (["username", "phone", "email", "nid", "isDisabled", "gender"].includes(field)) {
          if(!(["email" ].includes(field) && userFormValue[section][field] == "")){
              updatedUserData[field] = userFormValue[section][field];
            }
        } else
          updatedUserData.additionalData[field] = userFormValue[section][field];
        if (field == "blackListed" && this.userData.additionalData[field] !== updatedUserData.additionalData[field]) {
          updatedUserData.isDisabled = userFormValue[section][field] ? 1 : 0;
        }
        if (field == "birthdate") {
          if (this.calenderType === "gregorian") {
            updatedUserData.additionalData["birthdate"] =
              userFormValue[section][field];
            updatedUserData.additionalData["birthdateHijri"] = null;
          } else {
            // Format as Hijri string if it's a moment object
            const hijriValue = userFormValue[section][field];
            if (hijriValue && typeof hijriValue.format === "function") {
              const year = hijriValue.iYear();
              const month = (hijriValue.iMonth() + 1)
                .toString()
                .padStart(2, "0");
              const day = hijriValue.iDate().toString().padStart(2, "0");
              updatedUserData.additionalData[
                "birthdateHijri"
              ] = `${year}-${month}-${day}T00:00:00.000Z`;
            } else {
              // Optionally: convert native Date to Hijri moment first, then format
              if (hijriValue instanceof Date) {
                const hijriMoment = moment(hijriValue);
                const year = hijriMoment.iYear();
                const month = (hijriMoment.iMonth() + 1)
                  .toString()
                  .padStart(2, "0");
                const day = hijriMoment.iDate().toString().padStart(2, "0");
                updatedUserData.additionalData[
                  "birthdateHijri"
                ] = `${year}-${month}-${day}T00:00:00.000Z`;
              } else {
                updatedUserData.additionalData["birthdateHijri"] = hijriValue;
              }
            }
            updatedUserData.additionalData["birthdate"] = null;
          }
        }
      }

      try {
        this.isEditingUser = true;

        const clonedUserData = JSON.parse(
          JSON.stringify({
            roleId: RolesId[this.userRole],
            ...updatedUserData,
            additionalData: {
              ...this.userData.additionalData,
              ...updatedUserData.additionalData,
            },
          })
        );

        for (const data in updatedUserData.additionalData) {
          if (updatedUserData.additionalData[data] instanceof File) {
            delete clonedUserData.additionalData[data];

            clonedUserData.additionalData[data] = new File(
              [updatedUserData.additionalData[data]],
              updatedUserData.additionalData[data].name,
              { type: updatedUserData.additionalData[data].type }
            );
          }
        }

        // Update usename based on firstName and lastName
        clonedUserData.username = `${clonedUserData.additionalData.firstName} ${clonedUserData.additionalData.lastName}`;

        // For all users
        delete clonedUserData.userCasesCount;
        // For lawyers
        delete clonedUserData.totalWorkedMinutes;

        const phone = clonedUserData.phone;
        if (phone && !phone.startsWith("+966"))
          clonedUserData.phone = "+966" + phone;

        clonedUserData.verified = clonedUserData.isDisabled ? 0 : 1;
        await this._handleUsersService.updateUser(this.userId, clonedUserData);

        this.userData = { ...this.userData, ...clonedUserData };

        this.editableSection = null;
        this.dataService.notification("تم تعديل بيانات المستخدم بنجاح", 'success-snackbar');
        this._assignUserData(this.userData);
      } catch (error) {
        if (error.error.error.message == "Forbidden") {
          this.dataService.notification(
            "لا يمكن تعديل تلك البيانات",
            "error-snackbar"
          );
        }
        error.error?.error?.details?.forEach((error) => {
          if (error.path === ".email") {
            this._checkDuplicatedError(
              error.path,
              error.path,
              SavedUserData.CONTACT_DATA,
              "email"
            );
          }

          if (error.path === ".phone") {
            this._checkDuplicatedError(
              error.path,
              error.path,
              SavedUserData.CONTACT_DATA,
              "phone"
            );
          }

          if (error.path === ".nid") {
            this._checkDuplicatedError(
              error.path,
              error.path,
              SavedUserData.IDENTITY_DATA,
              "nid"
            );
          }
        });
      }

      this.isEditingUser = false;
    }
  }

  private _checkDuplicatedError(
    errorMessage: string,
    message: string,
    parentControl: SavedUserData,
    control: string
  ) {
    if (errorMessage.startsWith(message)) {
      addDuplicatedError(
        (this.saveUserForm.controls[parentControl] as FormGroup).controls[
        control
        ]
      );
    }
  }

  goBack() {
    this._router.navigate([`${this.userRole}-management`]);
  }

  copyApplicationNo(applicationNo: string) {
    this.currentCopiedText = applicationNo;
    navigator.clipboard.writeText(applicationNo);
  }

  deleteUser(userId: number) {
    this._dialog
      .open(ConfirmDialogComponent, {
        direction: this.translate.currentLang == "ar" ? "rtl" : "ltr",
        panelClass: "confirm-dialog",
        data: {
          content: this.translate.instant("confirm-dialog.confirm-delete-user"),
          icon: "delete_forever",
        },
      })
      .afterClosed()
      .subscribe(async (isDeleted) => {
        if (isDeleted) {
          try {
            this.isActionLoading = true;
            this._handleUsersService.deleteUser(userId);
            this.isActionLoading = false;
            this.dataService.notification(
              "تم حذف المستخدم بنجاح",
              "success-snackbar"
            );
            this.goBack();
          } catch (err) {
            this.isActionLoading = false;
          }
        }
      });
  }

  changeCalenderType(calenderType: 'hijri' | 'gregorian') {
    this.calenderType = calenderType;
  }
}
